import React, { Suspense } from "react";

import { Container } from "@cgc/ui/layout";
import DynamicLogo, { HeroLogo } from "./DynamicLogo";
import HeroImage from "./HeroImage";
import { DuaColumnProps } from "./types";

const DualColumnBenefitsHero: React.FC<DuaColumnProps> = ({
  id,
  fluid = true,
  copy,
  buttonsActionCopy,
  buttons = [],
  bottomCopy,
  backgroundColor,
  backgroundImage,
  imageLeft,
  benefits,
}) => {
  return (
    <Container
      id={id}
      fluid={fluid}
      className="bg-cgc-blue flex min-h-[435px] flex-col-reverse justify-between lg:flex-row xl:min-h-[420px] 2xl:min-h-[500px]"
      {...{ ...(backgroundColor ? { style: { backgroundColor } } : null) }}
    >
      {imageLeft && (
        <HeroImage backgroundImage={backgroundImage} benefits={benefits} />
      )}
      <div className="flex w-full flex-col items-center justify-center px-[15px] py-5 md:px-[50px] md:py-[30px] lg:w-1/2">
        <div className="relative z-10 flex flex-col items-center">
          {benefits?.length > 0 ? (
            <Suspense fallback={<HeroLogo />}>
              <DynamicLogo />
            </Suspense>
          ) : (
            <HeroLogo className="hidden lg:block" />
          )}
          <div className="pb-2.5">{copy}</div>
          {buttonsActionCopy && buttonsActionCopy}
          {buttons.length > 0 && (
            <div className="mt-2.5 flex w-full flex-row justify-center gap-[10px] md:w-auto">
              {buttons}
            </div>
          )}
          {bottomCopy && <div className="mt-2 text-white">{bottomCopy}</div>}
        </div>
      </div>
      {!imageLeft && (
        <HeroImage backgroundImage={backgroundImage} benefits={benefits} />
      )}
    </Container>
  );
};

export default DualColumnBenefitsHero;
